import {HttpError} from '@hconnect/common/types'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'

import {Api} from '../../../../../api'
import {settingsQueryClient} from '../../../../common/providers'
import {SignalDetail} from '../../../types/signal'
import {QueryKey as SignalsKey} from '../../SignalList/api/useGetSignals'

import {QueryKey as SignalDetailKey} from './useGetSignalDetail'

export const useCreateSignal = (successCb?: (signalId: string) => void) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()

  return useMutation({
    mutationFn: async (signalData: SignalDetail) => {
      const path = '/upm/signal'
      return (await Api.axiosInstance.post(path, signalData)).data
    },
    onSuccess: async (data: SignalDetail) => {
      settingsQueryClient.setQueryData([SignalDetailKey, data.id], data)
      await settingsQueryClient.invalidateQueries({
        queryKey: ['upmStructure'],
        exact: false
      })
      await settingsQueryClient.invalidateQueries({queryKey: [SignalsKey], exact: false})

      enqueueSnackbar('Signal created successfully', {
        variant: 'success',
        autoHideDuration: 2500,
        preventDuplicate: true,
        onClick: () => closeSnackbar()
      })
      successCb?.(data.id)
    },
    onError: (error: AxiosError<HttpError>) => {
      enqueueSnackbar(`Signal could not be created: ${error.message}`, {
        variant: 'error',
        preventDuplicate: true,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    }
  })
}
